import { createTypes } from 'redux-action-types'

export const types = createTypes('fridge/ui/',
  'CONTACT',
  'MANAGE_SIDEBAR'
)

export const contactSupport = () => ({type: types.CONTACT})
export const manageSidebar = () => ({type: types.MANAGE_SIDEBAR})



// WEBPACK FOOTER //
// ./app/actions/ui.js